export default __webpack_public_path__ + "static/media/93.f8c6ceb2.jpg";